import { BaseModel } from "@blue-chip/core";

export default class SearchResult extends BaseModel {}
